import React, { useState } from "react";
import Layout from "../Layout";
import Title from "../Title";
import summarizer from "../../assets/images/summarizerText.png"

export const ChatSummarizer = () => {
    const [text, setText] = useState("");
    const [summary, setSummary] = useState("");
    const [loading, setLoading] = useState(false);
    const [isResult, setIsResult]=useState(false)

    const runChatSummarizerQuery = async (inputText) => {
        try {
            const response = await fetch(
                "https://api-inference.huggingface.co/models/facebook/bart-large-cnn",
                {
                    headers: {
                        Authorization: "Bearer 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",
                        "Content-Type": "application/json",
                    },
                    method: "POST",
                    body: JSON.stringify({ inputs: inputText }),
                }
            );
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();
            return result?.[0]?.summary_text || "No summary available.";
        } catch (error) {
            console.error("Error fetching summary:", error);
            return "Error summarizing text.";
        }
    };

    const getWordCount = (text) => {
        return text.trim().split(/\s+/).filter(word => word.length > 0).length;
    };

    const handleTextChange = (event) => {
        setText(event.target.value);
    };

    const summarizeText = async () => {
        setLoading(true);

        const summarizedText = await runChatSummarizerQuery(text);
        setIsResult(true)
        setSummary(summarizedText);
        setLoading(false);
    };

    return (
        <>
            {/* <Title title="Workitems"></Title> */}
            {/* <Layout> */}

            <section className="Company_section common calender-group px-0">
                <div className="container banner-container px-0">
                    {/* <div> */}
                    {/* <div className="row"> */}
                    <div className="col-md-12 px-0">
                        <div className="ai-summarizer-container">
                        
                            <h2> <img src={summarizer} className="summarize-icon"></img>   Summarizer.ai</h2>

                            <div className="text-box">
                            <textarea className="ai-textarea"
                                value={text}
                                onChange={handleTextChange}
                                placeholder="Start typing or paste your content here..."
                            />
                            <div className="row">
                                <div className="col text-left">
                                    <div className="ai-count">Words: {getWordCount(text)}</div>


                                </div>
                                <div className="col text-right">
                                    <button
                                        className={`btn btn-primary ${loading ? "ai-loading" : ""}`}
                                        onClick={summarizeText}
                                        disabled={loading}
                                    >
                                        {loading ? "Summarizing..." : "Summarize"}
                                    </button>
                                </div>
                            </div>
                            </div>

                            {isResult && (
                                        <>
                                            <h2 className="mt-4">
                                                <img src={summarizer} className="summarize-icon" alt="Summarizer Icon" /> Results
                                            </h2>
                                            <div className="ai-output">
                                                <p>{summary}</p>
                                                <div className="ai-count">Words: {getWordCount(summary)}</div>
                                            </div>
                                        </>
                                    )}

                        </div>
                    </div>
                    {/* </div> */}
                    {/* </div> */}
                </div>
            </section>
            {/* </Layout> */}
        </>
    );
};

export default ChatSummarizer;